import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllTenantQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllTenant (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
                dialect
                host
                port
                username
                password
                database
            }
      }
    }
`
  

  export default query;